import { api } from './api.js';
export interface AgentRequestQuota {
    count: number;
    reserved: number;
    limit: number|null;
    remaining: number|null;
    startsAt: string;
    endsAt: string;
}
export interface AgentCapabilities {
    enabled: boolean;
    version: string;
    operations: Array<{
        name: string;
        description: string;
        external: boolean;
    }>;
    voice: boolean;
}
export interface AgentStep {
    id: string;
    operation: string;
    label: string;
    status: 'pending' | 'awaiting_input' | 'awaiting_approval' | 'running' | 'completed' | 'failed' | 'skipped';
    dependsOn: string[];
    input: Record<string, unknown>;
    result?: unknown;
    error?: unknown;
    approvalToken?: string;
    approvalPreview?: unknown;
    editor?: unknown;
    fields?: Record<string, string>;
}
export interface AgentRun {
    id: string;
    prompt: string;
    status: 'running' | 'waiting' | 'completed' | 'cancelled' | 'failed';
    revision: number;
    steps: AgentStep[];
    createdAt: string;
    updatedAt: string;
}
export const agentApi = {
    quota: () => api.get<AgentRequestQuota>('/voice/allowance'),
    capabilities: () => api.get<AgentCapabilities>('/agent/capabilities'),
    recent: () => api.get<{
        runs: AgentRun[];
    }>('/agent/runs'),
    get: (id: string) => api.get<AgentRun>(`/agent/runs/${encodeURIComponent(id)}`),
    create: (prompt: string, requestId: string) => api.post<AgentRun>('/agent/runs', { prompt, requestId }),
    advance: (run: AgentRun) => api.post<AgentRun>(`/agent/runs/${run.id}/advance`, { revision: run.revision }),
    continue: (run: AgentRun, step: AgentStep, input: unknown) => api.post<AgentRun>(`/agent/runs/${run.id}/steps/${step.id}/continue`, { revision: run.revision, input }),
    approve: (run: AgentRun, step: AgentStep) => api.post<AgentRun>(`/agent/runs/${run.id}/steps/${step.id}/approve`, { revision: run.revision, approvalToken: step.approvalToken }),
    cancel: (run: AgentRun) => api.post<AgentRun>(`/agent/runs/${run.id}/cancel`, { revision: run.revision }),
};
